import script from "./ParagrafoDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./ParagrafoDefault.vue?vue&type=script&setup=true&lang=js"

import "./ParagrafoDefault.vue?vue&type=style&index=0&id=3db2aa48&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db2aa48"]])

export default __exports__